import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ImageModalProps {
  src: string;
  alt?: string;
  className?: string;
  thumbnailClassName?: string;
  modalClassName?: string;
  highQualitySrc?: string; // Opcionális nagy felbontású kép URL
}

const ImageModal: React.FC<ImageModalProps> = ({
  src,
  alt = "Image preview",
  className = "",
  thumbnailClassName = "",
  modalClassName = "",
  highQualitySrc
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Használjuk a highQualitySrc-t ha meg van adva, egyébként az eredeti src-t
  const modalImageSrc = highQualitySrc || src;

  const openModal = () => {
    setIsOpen(true);
    // Megakadályozzuk a görgetést amikor a modal nyitva van
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsOpen(false);
    // Visszaállítjuk a görgetést
    document.body.style.overflow = '';
  };

  // Ha ESC-et nyomunk, bezárjuk a modalt
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  return (
    <div className={`relative ${className}`}>
      {/* Thumbnail kép */}
      <div 
        className={`cursor-pointer ${thumbnailClassName}`}
        onClick={openModal}
      >
        <img 
          src={src} 
          alt={alt} 
          className="w-full h-full object-contain"
        />
      </div>

      {/* Modal */}
      {isOpen && (
        <div
          className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div 
            className={`bg-white rounded-lg shadow-2xl max-w-5xl max-h-[95vh] w-[95vw] sm:w-auto overflow-hidden ${modalClassName}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <button
                className="absolute top-2 right-2 p-1 rounded-full bg-white/80 hover:bg-white text-gray-700 hover:text-gray-900 z-10 transition-colors"
                onClick={closeModal}
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
              <div className="p-1">
                <img 
                  src={modalImageSrc} 
                  alt={alt} 
                  className="max-w-full max-h-[85vh] object-contain mx-auto"
                  style={{ 
                    minWidth: 'min(600px, 90vw)', 
                    minHeight: 'min(400px, 70vh)'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageModal; 